module.exports = __webpack_public_path__ + "ca0654b00da0010cd751c8302cb451e1.png";